module.exports = __webpack_public_path__ + "static/assets/725089014557d28fd2c38904a6326b81.svg";